import { getWebSocketHost } from "src/utils/activeApiEndpoint";

import { SyncFollowStreamManager } from "./syncFollowStreamManager";

export class SextantStreamManager extends SyncFollowStreamManager {
  init(fabricId: string | undefined) {
    if (fabricId) {
      this.connectSocket(
        () =>
          `wss://${getWebSocketHost()}/stream/v1/fabrics/${fabricId}/telemetry`
      );
    }
  }
}
